"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    // FETCH
    function fetchRequest(type, id, params = {}) {
        return {
            type: _ActionTypes.FETCH_REQUEST,
            payload: { type, id, params }
        };
    }
    function fetchSuccess(groups) {
        return {
            type: _ActionTypes.FETCH_SUCCESS,
            payload: groups
        };
    }
    function fetchFailed(error) {
        return {
            type: _ActionTypes.FETCH_FAILED,
            payload: error
        };
    }
    function collapseUserRow(id, isCollapsed) {
        return {
            type: _ActionTypes.COLLAPSE_USER_ROW,
            payload: {
                id,
                isCollapsed
            }
        };
    }
    function setGroupsSelected(items, selected) {
        return {
            type: _ActionTypes.SET_GROUPS_SELECTED,
            payload: {
                items,
                selected
            }
        };
    }
    function setUsersSelected(items, selected) {
        return {
            type: _ActionTypes.SET_USERS_SELECTED,
            payload: {
                items,
                selected
            }
        };
    }
    function setSortingSelector(sortBy) {
        return {
            type: _ActionTypes.SET_SORTING_SELECTOR,
            sortBy
        };
    }
    function setColumnFilter(filter, value) {
        return {
            type: _ActionTypes.SET_COLUMN_FILTER,
            payload: {
                filter,
                value
            }
        };
    }
    function searchGroups(searchString) {
        return {
            type: _ActionTypes.SEARCH_GROUPS,
            searchString
        };
    }
    function clear() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    return {
        fetchRequest,
        fetchSuccess,
        fetchFailed,
        setColumnFilter,
        collapseUserRow,
        setGroupsSelected,
        setUsersSelected,
        setSortingSelector,
        searchGroups,
        clear
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map